import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/font/iconfont.css'
import echarts from "echarts";
import "swiper/css/swiper.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/store'

import Nav from "./components/Nav/Nav.vue"
import Footer from "./components/Footer/Footer.vue"
// import Modal from "./components/Modal/Modal.vue"

Vue.component(Nav.name, Nav)
Vue.component(Footer.name, Footer)
// Vue.component(Modal.name, Modal)

Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
